export const GETTER_LIST_REWARD_HISTORY_EMPLOYEE =
  "GETTER_LIST_REWARD_HISTORY_EMPLOYEE";
export const GETTER_LIST_REWARD_HISTORY_EMPLOYEE_PAGINATION =
  "GETTER_LIST_REWARD_HISTORY_EMPLOYEE_PAGINATION";
export const GETTER_LIST_REWARD_HISTORY_PROGRAM =
  "GETTER_LIST_REWARD_HISTORY_PROGRAM";
export const GETTER_LIST_REWARD_HISTORY_PROGRAM_PAGINATION =
  "GETTER_LIST_REWARD_HISTORY_PROGRAM_PAGINATION";

export const ACTION_GET_LIST_REWARD_HISTORY_EMPLOYEE =
  "ACTION_GET_LIST_REWARD_HISTORY_EMPLOYEE";
export const ACTION_GET_LIST_REWARD_HISTORY_PROGRAM =
  "ACTION_GET_LIST_REWARD_HISTORY_PROGRAM";

export const MUTATION_SET_LIST_REWARD_HISTORY_EMPLOYEE =
  "MUTATION_SET_LIST_REWARD_HISTORY_EMPLOYEE";
export const MUTATION_SET_LIST_REWARD_HISTORY_PROGRAM =
  "MUTATION_SET_LIST_REWARD_HISTORY_PROGRAM";

export const REWARD_HISTORY_STATUS = {
  COMPLETED: "Completed",
  INPROGRESS: "In Progress",
  CANCEL: "Cancel"
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_rewards_history/constants.js